export default {"src":"/_next/static/image/public/images/ic_bookmark_white_vertical_menu.f8115fbfccce4473448ed41752dcedc6.svg","height":20,"width":20};